import {
    WF_ACTIVITY_REGISTRY,
    WfActivityRegistryEntry
} from '../../feature-core/wf/interface/wf-activity-registry';
import {
    PcCallWfProcessStepActivitySideComponent
} from './component/protected-components/wf/pc-call-wf-process-step-activity-side/pc-call-wf-process-step-activity-side.component';

export const PC_WF_ACTIVITY_PROVIDER = [{
    provide: WF_ACTIVITY_REGISTRY,
    useValue: [
        ['module_activity:pc.Call', {sideComponent: PcCallWfProcessStepActivitySideComponent}],
    ] as WfActivityRegistryEntry[],
    multi: true
}];
